// Useful for methods that have callback methods
const makeAsynchronous = (method: (data: unknown) => void) => {
  return new Promise((resolve) => {
    method((data: unknown) => {
      resolve(data)
    })
  })
}

export default makeAsynchronous
